module.exports = __webpack_public_path__ + "static/app-store-f065987813793af515be08b4db6b81e8.svg";